import { createAction } from 'typesafe-actions';

export const openSidebar = createAction('OPEN_SIDEBAR')<undefined>();
export const closeSidebar = createAction('CLOSE_SIDEBAR')<undefined>();
